import type { InternalTreeMapNode } from '../types/internal.js';

const hasValue = (node: InternalTreeMapNode) => node.value > 0;

/**
 * Function to copy and filter tree 2 levels deep
 * @param rootNode - TreeMap root node
 * @returns - filtered TreeMap root node
 */
export const getFilteredTree = (rootNode: InternalTreeMapNode) => {
  const clusters = [...(rootNode.children ?? [])].filter(hasValue);

  const children = clusters.map((cluster) => {
    const { children, ...clusterRest } = cluster;
    return {
      ...clusterRest,
      children: [...(cluster.children ?? [])].filter(hasValue),
    };
  });

  return { ...rootNode, children };
};
